import { Component, Input } from "@angular/core";

@Component({
    selector: "no-content-message",
    templateUrl: "./nocontentmessage.component.html",
    standalone: false
})
export class NoContentMessageComponent {
    @Input() message!: string;
    @Input() visible!: boolean;

}